/* eslint-disable import/max-dependencies */
import React from "react";
import { Helmet } from "react-helmet";
import { Grid, Container } from "@mui/material";
import PagesContainer from "../../containers/PagesContainer";
import ClonePageDialog from "../../containers/ClonePageDialog";
import ExportPageDialog from "../../containers/ExportPageDialog";
import ImportPageDialog from "../../containers/ImportPageDialog";
import { mainBackgroundStyles } from "../../styles/common";

function Pages() {
  return (
    <>
      <Helmet>
        <title>Page List</title>
      </Helmet>
      <Grid
        container
        spacing={0}
        sx={mainBackgroundStyles}
      >
        <Container maxWidth={false}>
          <PagesContainer />
          <ClonePageDialog />
          <ExportPageDialog />
          <ImportPageDialog />
        </Container>
      </Grid>
    </>
  );
}

export default Pages;
